import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import type { LoadingSkeletonProps } from './types';
import './loadingSkeleton.scss';

/**
 * Wraps content with a Skeleton placeholder while it loads. Returns the bare Skeleton in place of children when isWrap is false, otherwise renders the skeleton alongside children inside a wrapper div, forwarding the remaining props to Skeleton and yielding only children once loading ends.
 *
 * @param props - The loading and wrapping flags, wrapper class name, children to reveal and any remaining Skeleton props.
 * @returns The skeleton placeholder while loading, otherwise the children.
 */
const LoadingSkeleton = (props: LoadingSkeletonProps) => {
  const {
    className = undefined,
    children,
    isLoading = true,
    isWrap = true,
    ...propsSkeleton
  } = props;

  if (!isWrap) {
    return isLoading ? <Skeleton {...propsSkeleton} /> : children;
  }

  return isLoading ? (
    <div className={classNames('skeleton-wrapper', className)}>
      <Skeleton className="skeleton-child" {...propsSkeleton} />
      {children}
    </div>
  ) : (
    children
  );
};

export default LoadingSkeleton;
